export const en = {
  findings: 'Findings for your review',
  identityNeedsReview: 'Identity needs your review',
  generationStatus: 'Generation status',
  generatedAwaitingReview:
    'Generated findings require human confirmation. Generation completion does not mean approval.',
  identityReasoning: 'Identity attribution',
  submittedInformation: 'Submitted information',
  submittedInformationExplanation:
    'The profile above contains submitted information. Independently corroborated facts appear below with their sources.',
  corroboratedProfile: 'Corroborated profile',
  companyRelationships: 'Company and member relationships',
  investigationFindings: 'Generated findings',
  coverageLimitations: 'Research limitations',
  acceptanceBlocked: 'Acceptance is blocked until these essential checks are completed.',
  essentialChecksComplete: 'Essential checks completed',
  essentialChecksIncomplete: 'Essential checks incomplete',
  identityUnresolved: 'Available evidence did not resolve this subject’s identity.',
  researchStopped: 'Research stopping reason',
  evidenceQuote: 'Supporting evidence',
  retryUnavailable: 'Research cannot resume under the current limits. Generate a new report.',
  currentRiskExplanation: 'Current risk explanation',

  researchDiagnostics: 'Research diagnostics',
  unassessed: 'Unassessed',
  legacyAssessment:
    'This report used an earlier research engine. Create a new report to reassess it; the historical assessment is preserved.',
  informationalBackground: 'Informational background',
  documentExpiryWarning:
    'The primary identity document is expired. This is a document warning, not evidence of misconduct.',
  selectReportType: 'Select report type',
  selectTheTypeOfReportYouWantToCreate: 'Select the type of report you want to create.',
  uploadCompanyLegalDocuments: 'Upload company legal documents',
  selectAndUploadDocumentsForAtLeastOneOption:
    'Select and upload documents for at least one option.',
  uploadAdditionalDocumentsOptional: 'Upload additional documents (optional)',
  anySupportingDocumentsRelatedToTheBusinessIfAvailable:
    'Any supporting documents related to the business, if available.',
  enterKeyStakeholdersMembers: 'Enter Key Stakeholders & Members',
  addTheKeyIndividualsAssociatedWithTheBusinessDirectors:
    'Add the key individuals associated with the business (directors, shareholders, beneficial owners).',
  completeBusinessInformationForm: 'Complete business information form',
  checkAndFinalizeTheCompanySDetails: "Check and finalize the company's details.",
  uploadClientIdentificationId: 'Upload client identification (ID)',
  provideTheClientSIdentityDocumentForVerification:
    "Provide the client's identity document for verification.",
  anySupportingDocumentsRelatedToTheClientIfAvailable:
    'Any supporting documents related to the client, if available.',
  completeClientInformationForm: 'Complete client information form',
  checkAndFinalizeTheClientSDetails: "Check and finalize the client's details.",
  step: 'Step',
  of: 'of',
  failedToStartAutofill: 'Failed to start autofill',
  pleaseTryAgain: 'Please try again.',
  youHaveAddedContentToThisReportLeavingNow:
    'You have added content to this report. Leaving now may lose your progress.',
  uploadFailed: 'Upload failed',
  fileRemoved: 'File removed',
  failedToRemoveFile: 'Failed to remove file',
  autofillCouldNotComplete: 'Autofill could not complete',
  youCanRetryAutomaticPreFillOrContinueAnd:
    'You can retry automatic pre-fill or continue and enter details manually on the next step.',
  retryAutofill: 'Retry autofill',
  uploadAnySupportingDocumentsCertificatesBankStatementsUtilityBills:
    'Upload any supporting documents (certificates, bank statements, utility bills, etc.). This step is optional — you can skip it and proceed directly to the next step.',
  uploadedFiles: 'Uploaded files',
  documentPreview: 'document preview',
  uploaded: 'Uploaded',
  uploading: 'Uploading…',
  dropFilesHere: 'Drop files here',
  dropFilesOrClickToBrowse: 'Drop files or click to browse',
  pdfJpgPngWebpMultipleFilesAllowedMax20:
    'PDF, JPG, PNG, WEBP · multiple files allowed · max 20 MB each',
  noAdditionalFilesRequired: 'No additional files required',
  skip: 'Skip',
  analysingYourDocuments: 'Analysing your documents…',
  weRePreFillingTheNextStepYouLl:
    "We're pre-filling the next step. You'll be moved forward automatically when ready.",
  newReport: 'New Report',
  selectTheTypeOfDueDiligenceReviewToBegin:
    'Select the type of due diligence review to begin. This determines the required documents and verification scope.',
  reviewType: 'Review type',
  individualKycReviewForIndividualClients: 'Individual (KYC) - Review for individual clients',
  individual: 'Individual',
  reviewForIndividualClientsKyc: 'Review for individual clients (KYC)',
  businessKybReviewForBusinessClientsAndKeyIndividuals:
    'Business (KYB) - Review for business clients and key individuals',
  business: 'Business',
  reviewForBusinessClientsIncludingTheBusinessEntityAnd:
    'Review for business clients, including the business entity and its key individuals (KYB)',
  cancel: 'Cancel',
  creating: 'Creating...',
  startDueDiligence: 'Start Due Diligence',
  passport: 'Passport',
  nationalId: 'National ID',
  residencyPermit: 'Residency Permit',
  voterId: 'Voter ID',
  certificateOfIncorporation: 'Certificate of Incorporation',
  tradeLicense: 'Trade License',
  commercialRegistryExtract: 'Commercial Registry Extract',
  mergerAcquisitionDocument: 'Merger & Acquisition Document',
  selectADocumentTypeFirst: 'Select a document type first',
  youHaveStartedUploadingDocumentsForThisReportLeaving:
    'You have started uploading documents for this report. Leaving now may lose your progress.',
  fileUploaded: 'File uploaded',
  selectDocumentType: 'Select document type',
  frontBack: '(front & back)',
  changeDocumentType: 'Change document type',
  documentExtractionFailedPleaseDeleteAndReUploadThe:
    'Document extraction failed. Please delete and re-upload the affected file(s).',
  dropTheFileHere: 'Drop the file here',
  dropFileOrClickToBrowse: 'Drop file or click to browse',
  pdfJpgPngWebpMax20Mb: 'PDF, JPG, PNG, WEBP · max 20 MB',
  waitingForExtraction: 'Waiting for extraction',
  extractingData: 'Extracting data…',
  extractionComplete: 'Extraction complete',
  extractionFailed: 'Extraction failed',
  failedToStartExtraction: 'Failed to start extraction',
  extractionAccepted: 'Extraction accepted',
  failedToAcceptExtraction: 'Failed to accept extraction',
  documentsRemovedPleaseUploadNewFiles: 'Documents removed. Please upload new files.',
  failedToRejectExtraction: 'Failed to reject extraction',
  extractingDocumentData: 'Extracting document data…',
  reviewExtractedData: 'Review extracted data',
  documents: 'Documents',
  preview: 'Preview',
  documentPreview2: 'Document preview',
  documentPreviewWillAppearHereOnceTheDownloadUrl:
    'Document preview will appear here once the download URL endpoint is configured.',
  extractedFields: 'Extracted fields',
  acceptContinue: 'Accept & continue',
  rejectReUpload: 'Reject & re-upload',
  pending: 'Pending',
  processing: 'Processing',
  done: 'Done',
  failed: 'Failed',
  validation: 'Validation',
  validDocument: 'Valid Document',
  invalidDocument: 'Invalid Document',
  expired: 'Expired',
  notExpired: 'Not Expired',
  expires: 'Expires ',
  documentWarnings: 'Document warnings',
  firstName: 'First Name',
  lastName: 'Last Name',
  dateOfBirth: 'Date of Birth',
  placeOfBirth: 'Place of Birth',
  nationality: 'Nationality',
  residenceCountry: 'Residence Country',
  taxIdentificationNumber: 'Tax Identification Number',
  idNumber: 'ID Number',
  phone: 'Phone',
  email: 'Email',
  address: 'Address',
  employmentStatus: 'Employment Status',
  sourceOfFunds: 'Source of Funds',
  clientInformation: 'Client Information',
  documentNumber: 'Document Number',
  expiryDate: 'Expiry Date',
  sex: 'Sex',
  mrzData: 'MRZ Data',
  mrzRaw: 'MRZ Raw',
  companyName: 'Company Name',
  companyRegistrationNumber: 'Company Registration Number',
  companyIdNumber: 'Company ID Number',
  companyTaxId: 'Company Tax ID',
  sector: 'Sector',
  industry: 'Industry',
  countryOfIncorporation: 'Country of Incorporation',
  companyInformation: 'Company Information',
  keyMembers: 'Key Members',
  noExtractedDataAvailableForThisDocument: 'No extracted data available for this document.',
  readingDocument: 'Reading document...',
  reportSubmittedSuccessfully: 'Report submitted successfully',
  failedToSubmitReport: 'Failed to submit report',
  pleaseCheckTheFormAndRetry: 'Please check the form and retry.',
  youHaveEditedCompanyInformationLeavingNowMayLose:
    'You have edited company information. Leaving now may lose unsaved changes.',
  saving: 'Saving…',
  saved: 'Saved',
  companyIdentity: 'Company identity',
  companyName2: 'Company name',
  registrationNumber: 'Registration number',
  companyIdNumber2: 'Company ID number',
  taxId: 'Tax ID',
  countryOfIncorporation2: 'Country of incorporation',
  incorporationDate: 'Incorporation date',
  yyyyMmDd: 'YYYY-MM-DD',
  businessActivity: 'Business activity',
  registeredAddress: 'Registered address',
  financialProfile: 'Financial profile',
  annualRevenue: 'Annual revenue',
  netWorth: 'Net worth',
  ultimateBeneficialOwners: 'Ultimate beneficial owners',
  directors: 'Directors',
  contact: 'Contact',
  contactEmail: 'Contact email',
  contactPhone: 'Contact phone',
  submitReport: 'Submit report',
  youHaveEditedKeyMemberDetailsLeavingNowMay:
    'You have edited key member details. Leaving now may lose unsaved changes.',
  member: 'member',
  addKeyMember: 'Add key member',
  firstName2: 'First name',
  lastName2: 'Last name',
  roleTitle: 'Role / Title',
  dateOfBirth2: 'Date of birth',
  placeOfBirth2: 'Place of birth',
  countryOfResidence: 'Country of residence',
  idNumber2: 'ID number',
  taxIdNumber: 'Tax ID number',
  sourceOfFundsIncome: 'Source of funds / income',
  estimatedNetWorth: 'Estimated net worth',
  youHaveEditedClientInformationLeavingNowMayLose:
    'You have edited client information. Leaving now may lose unsaved changes.',
  identity: 'Identity',
  identificationDocument: 'Identification document',
  idPassportNumber: 'ID / Passport number',
  taxIdentificationNumber2: 'Tax identification number',
  employmentStatus2: 'Employment status',
  sourceOfFunds2: 'Source of funds',
  accountUsePurpose: 'Account use / purpose',
  knowYourCustomerKyc: 'Know Your Customer (KYC)',
  knowYourBusinessKyb: 'Know Your Business (KYB)',
  couldNotDiscardReport: 'Could not discard report',
  reportType: 'Report type',
  youChoseThisVerificationPathForThisReportTo:
    'You chose this verification path for this report. To pick a different type you must start over.',
  changeReportType: 'Change report type',
  changeReportType2: 'Change report type?',
  switchingTheReportTypeWillPermanentlyDiscardThisDraft:
    'Switching the report type will permanently discard this draft and all uploaded files. This cannot be undone.',
  discarding: 'Discarding…',
  discardAndStartOver: 'Discard and start over',
  clientName: 'Client Name',
  clientType: 'Client Type',
  status: 'Status',
  riskLevel: 'Risk Level',
  actions: 'Actions',
  savedDraft: 'Saved Draft',
  clientAdded: '✓ Client Added',
  clientRejected: '× Client Rejected',
  pendingReview: '? Pending Review',
  continueDraft: 'Continue draft',
  viewReport: 'View report',
  reportPending: 'Report pending',
  availableWhenGenerationIsComplete: 'Available when generation is complete',
  noReportsMatchTheseFilters: 'No reports match these filters.',
  reportStatus: 'Report status',
  completed: 'Completed',
  inProgress: 'In Progress',
  savedDrafts: 'Saved Drafts',
  type: 'Type',
  allTypes: 'All Types',
  kyc: 'KYC',
  kyb: 'KYB',
  period: 'Period',
  allTime: 'All Time',
  thisWeek: 'This Week',
  last30Days: 'Last 30 Days',
  last6Months: 'Last 6 Months',
  lastYear: 'Last Year',
  drafts: 'Drafts',
  inProgress2: 'In Progress (',
  completed2: 'Completed (',
  pendingReview2: 'Pending Review',
  failedPartial: 'Failed / Partial',
  riskFilter: 'Risk Filter',
  allRisks: 'All Risks',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  reportHistory: 'Report History',
  myReports: 'My Reports',
  reportsFound: 'reports found',
  showing: 'Showing',
  reportGenerationRestarted: 'Report generation restarted.',
  retryReportGeneration: 'Retry report generation',
  errorLoadingReports: 'Error loading reports',
  searchReportsByNameTypeIdOrCaseId: 'Search reports by name, type, ID, or case ID...',
  reportType2: 'Report Type',
  inProcess: 'In Process (',
  noReportsFound: 'No reports found',
  noReportsMatchYourSearchCriteria: 'No reports match your search criteria.',
  thereAreNoReportsAvailableAtTheMoment: 'There are no reports available at the moment.',
} as const;
export const fa: Record<keyof typeof en, string> = {
  findings: 'یافته‌ها برای بررسی شما',
  identityNeedsReview: 'هویت نیاز به بررسی شما دارد',
  generationStatus: 'وضعیت تهیه گزارش',
  generatedAwaitingReview:
    'یافته‌های تولیدشده نیازمند تأیید انسانی هستند. پایان تهیه گزارش به معنی پذیرش نیست.',
  identityReasoning: 'دلایل تطبیق هویت',
  submittedInformation: 'اطلاعات ارائه‌شده',
  submittedInformationExplanation:
    'پروفایل بالا شامل اطلاعات ارائه‌شده است. اطلاعات دارای تأیید مستقل همراه با منابع در ادامه آمده‌اند.',
  corroboratedProfile: 'اطلاعات دارای شواهد مستقل',
  companyRelationships: 'روابط شرکت و اعضا',
  investigationFindings: 'یافته‌های تولیدشده',
  coverageLimitations: 'محدودیت‌های تحقیق',
  acceptanceBlocked: 'پذیرش تا تکمیل بررسی‌های ضروری زیر امکان‌پذیر نیست.',
  essentialChecksComplete: 'بررسی‌های ضروری تکمیل شده‌اند',
  essentialChecksIncomplete: 'بررسی‌های ضروری ناقص هستند',
  identityUnresolved: 'شواهد موجود برای تعیین هویت این شخص یا شرکت کافی نبود.',
  researchStopped: 'دلیل توقف تحقیق',
  evidenceQuote: 'شواهد پشتیبان',
  retryUnavailable: 'ادامه تحقیق با محدودیت‌های فعلی ممکن نیست. گزارش جدیدی تهیه کنید.',
  currentRiskExplanation: 'دلایل ارزیابی فعلی ریسک',

  researchDiagnostics: 'جزئیات خطاهای تحقیق',
  unassessed: 'ارزیابی‌نشده',
  legacyAssessment: 'این گزارش با نسخه قبلی تهیه شده و نیازمند ارزیابی مجدد است.',
  informationalBackground: 'اطلاعات زمینه‌ای',
  documentExpiryWarning: 'مدرک منقضی شده است؛ این هشدار به‌تنهایی ریسک سوءرفتار نیست.',

  selectReportType: 'انتخاب نوع گزارش',
  selectTheTypeOfReportYouWantToCreate: 'نوع گزارشی را که می‌خواهید تهیه کنید انتخاب کنید.',
  uploadCompanyLegalDocuments: 'بارگذاری مدارک ثبتی شرکت',
  selectAndUploadDocumentsForAtLeastOneOption: 'برای دست‌کم یکی از گزینه‌ها مدرک بارگذاری کنید.',
  uploadAdditionalDocumentsOptional: 'بارگذاری مدارک تکمیلی (اختیاری)',
  anySupportingDocumentsRelatedToTheBusinessIfAvailable:
    'در صورت نیاز، سایر مدارک مربوط به کسب‌وکار را اضافه کنید.',
  enterKeyStakeholdersMembers: 'افراد کلیدی و ذی‌نفعان',
  addTheKeyIndividualsAssociatedWithTheBusinessDirectors:
    'اطلاعات مدیران، سهام‌داران و مالکان نهایی کسب‌وکار را وارد کنید.',
  completeBusinessInformationForm: 'تکمیل اطلاعات شرکت',
  checkAndFinalizeTheCompanySDetails: 'اطلاعات شرکت را بررسی و تأیید کنید.',
  uploadClientIdentificationId: 'بارگذاری مدرک هویتی مشتری',
  provideTheClientSIdentityDocumentForVerification:
    'برای احراز هویت، مدرک شناسایی مشتری را بارگذاری کنید.',
  anySupportingDocumentsRelatedToTheClientIfAvailable:
    'در صورت نیاز، سایر مدارک مربوط به مشتری را اضافه کنید.',
  completeClientInformationForm: 'تکمیل اطلاعات مشتری',
  checkAndFinalizeTheClientSDetails: 'اطلاعات مشتری را بررسی و تأیید کنید.',
  step: 'مرحله',
  of: 'از',
  failedToStartAutofill: 'تکمیل خودکار شروع نشد',
  pleaseTryAgain: 'لطفاً دوباره تلاش کنید.',
  youHaveAddedContentToThisReportLeavingNow:
    'اطلاعاتی به این گزارش اضافه کرده‌اید. با خروج ممکن است تغییرات ذخیره نشوند.',
  uploadFailed: 'بارگذاری انجام نشد',
  fileRemoved: 'فایل حذف شد',
  failedToRemoveFile: 'فایل حذف نشد',
  autofillCouldNotComplete: 'تکمیل خودکار انجام نشد',
  youCanRetryAutomaticPreFillOrContinueAnd:
    'می‌توانید دوباره تلاش کنید یا در مرحله بعد اطلاعات را دستی وارد کنید.',
  retryAutofill: 'تلاش دوباره',
  uploadAnySupportingDocumentsCertificatesBankStatementsUtilityBills:
    'مدارک تکمیلی مانند گواهی‌ها، صورت‌حساب بانکی یا قبض را بارگذاری کنید. این مرحله اختیاری است و می‌توانید از آن بگذرید.',
  uploadedFiles: 'فایل‌های بارگذاری‌شده',
  documentPreview: 'پیش‌نمایش مدرک',
  uploaded: 'بارگذاری شد',
  uploading: 'در حال بارگذاری…',
  dropFilesHere: 'فایل‌ها را اینجا رها کنید',
  dropFilesOrClickToBrowse: 'فایل‌ها را اینجا بکشید یا برای انتخاب کلیک کنید',
  pdfJpgPngWebpMultipleFilesAllowedMax20:
    'PDF، JPG، PNG، WEBP · امکان انتخاب چند فایل · حداکثر ۲۰ مگابایت برای هر فایل',
  noAdditionalFilesRequired: 'مدرک تکمیلی لازم نیست',
  skip: 'رد شدن از این مرحله',
  analysingYourDocuments: 'در حال بررسی مدارک…',
  weRePreFillingTheNextStepYouLl:
    'اطلاعات مرحله بعد از روی مدارک تکمیل می‌شود. پس از آماده شدن، خودکار به مرحله بعد می‌روید.',
  newReport: 'گزارش جدید',
  selectTheTypeOfDueDiligenceReviewToBegin:
    'نوع بررسی را انتخاب کنید تا مدارک موردنیاز و محدوده بررسی مشخص شود.',
  reviewType: 'نوع بررسی',
  individualKycReviewForIndividualClients: 'حقیقی (KYC) ـ بررسی اشخاص',
  individual: 'حقیقی',
  reviewForIndividualClientsKyc: 'بررسی مشتریان حقیقی (KYC)',
  businessKybReviewForBusinessClientsAndKeyIndividuals: 'حقوقی (KYB) ـ بررسی کسب‌وکار و افراد کلیدی',
  business: 'حقوقی',
  reviewForBusinessClientsIncludingTheBusinessEntityAnd: 'بررسی کسب‌وکار و افراد کلیدی آن (KYB)',
  cancel: 'انصراف',
  creating: 'در حال ایجاد…',
  startDueDiligence: 'شروع بررسی',
  passport: 'گذرنامه',
  nationalId: 'کارت ملی',
  residencyPermit: 'کارت اقامت',
  voterId: 'کارت رأی‌دهنده',
  certificateOfIncorporation: 'گواهی ثبت شرکت',
  tradeLicense: 'مجوز فعالیت',
  commercialRegistryExtract: 'استعلام ثبت تجاری',
  mergerAcquisitionDocument: 'سند ادغام یا تملک',
  selectADocumentTypeFirst: 'ابتدا نوع مدرک را انتخاب کنید',
  youHaveStartedUploadingDocumentsForThisReportLeaving:
    'بارگذاری مدارک را شروع کرده‌اید. با خروج ممکن است تغییرات ذخیره نشوند.',
  fileUploaded: 'فایل بارگذاری شد',
  selectDocumentType: 'انتخاب نوع مدرک',
  frontBack: '(رو و پشت)',
  changeDocumentType: 'تغییر نوع مدرک',
  documentExtractionFailedPleaseDeleteAndReUploadThe:
    'استخراج اطلاعات انجام نشد. فایل مربوطه را حذف و دوباره بارگذاری کنید.',
  dropTheFileHere: 'فایل را اینجا رها کنید',
  dropFileOrClickToBrowse: 'فایل را اینجا بکشید یا برای انتخاب کلیک کنید',
  pdfJpgPngWebpMax20Mb: 'PDF، JPG، PNG، WEBP · حداکثر ۲۰ مگابایت',
  waitingForExtraction: 'در انتظار استخراج اطلاعات',
  extractingData: 'در حال استخراج اطلاعات…',
  extractionComplete: 'استخراج اطلاعات تکمیل شد',
  extractionFailed: 'استخراج اطلاعات انجام نشد',
  failedToStartExtraction: 'استخراج اطلاعات شروع نشد',
  extractionAccepted: 'اطلاعات تأیید شد',
  failedToAcceptExtraction: 'تأیید اطلاعات انجام نشد',
  documentsRemovedPleaseUploadNewFiles: 'مدارک حذف شدند. فایل‌های جدید را بارگذاری کنید.',
  failedToRejectExtraction: 'رد اطلاعات انجام نشد',
  extractingDocumentData: 'در حال استخراج اطلاعات مدرک…',
  reviewExtractedData: 'بررسی اطلاعات استخراج‌شده',
  documents: 'مدارک',
  preview: 'پیش‌نمایش',
  documentPreview2: 'پیش‌نمایش مدرک',
  documentPreviewWillAppearHereOnceTheDownloadUrl:
    'پس از تنظیم آدرس دانلود، پیش‌نمایش مدرک اینجا نمایش داده می‌شود.',
  extractedFields: 'اطلاعات استخراج‌شده',
  acceptContinue: 'تأیید و ادامه',
  rejectReUpload: 'رد و بارگذاری مجدد',
  pending: 'در انتظار بررسی',
  processing: 'در حال پردازش',
  done: 'انجام شد',
  failed: 'ناموفق',
  validation: 'اعتبارسنجی',
  validDocument: 'مدرک معتبر',
  invalidDocument: 'مدرک نامعتبر',
  expired: 'منقضی شده',
  notExpired: 'دارای اعتبار',
  expires: 'تاریخ انقضا',
  documentWarnings: 'هشدارهای مدرک',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  dateOfBirth: 'تاریخ تولد',
  placeOfBirth: 'محل تولد',
  nationality: 'ملیت',
  residenceCountry: 'کشور محل اقامت',
  taxIdentificationNumber: 'شناسه مالیاتی',
  idNumber: 'شماره شناسایی',
  phone: 'تلفن',
  email: 'ایمیل',
  address: 'نشانی',
  employmentStatus: 'وضعیت اشتغال',
  sourceOfFunds: 'منبع درآمد',
  clientInformation: 'اطلاعات مشتری',
  documentNumber: 'شماره مدرک',
  expiryDate: 'تاریخ انقضا',
  sex: 'جنسیت',
  mrzData: 'اطلاعات ناحیه ماشین‌خوان',
  mrzRaw: 'متن ناحیه ماشین‌خوان',
  companyName: 'نام شرکت',
  companyRegistrationNumber: 'شماره ثبت شرکت',
  companyIdNumber: 'شناسه شرکت',
  companyTaxId: 'شناسه مالیاتی شرکت',
  sector: 'حوزه فعالیت',
  industry: 'صنعت',
  countryOfIncorporation: 'کشور محل ثبت',
  companyInformation: 'اطلاعات شرکت',
  keyMembers: 'افراد کلیدی',
  noExtractedDataAvailableForThisDocument: 'اطلاعاتی از این مدرک استخراج نشده است.',
  readingDocument: 'در حال خواندن مدرک…',
  reportSubmittedSuccessfully: 'گزارش ثبت شد',
  failedToSubmitReport: 'گزارش ثبت نشد',
  pleaseCheckTheFormAndRetry: 'اطلاعات فرم را بررسی کنید و دوباره تلاش کنید.',
  youHaveEditedCompanyInformationLeavingNowMayLose:
    'اطلاعات شرکت را تغییر داده‌اید. با خروج ممکن است تغییرات ذخیره نشوند.',
  saving: 'در حال ذخیره…',
  saved: 'ذخیره شد',
  companyIdentity: 'مشخصات شرکت',
  companyName2: 'نام شرکت',
  registrationNumber: 'شماره ثبت',
  companyIdNumber2: 'شناسه شرکت',
  taxId: 'شناسه مالیاتی',
  countryOfIncorporation2: 'کشور محل ثبت',
  incorporationDate: 'تاریخ تأسیس',
  yyyyMmDd: 'سال-ماه-روز',
  businessActivity: 'موضوع فعالیت',
  registeredAddress: 'نشانی ثبتی',
  financialProfile: 'اطلاعات مالی',
  annualRevenue: 'درآمد سالانه',
  netWorth: 'خالص دارایی',
  ultimateBeneficialOwners: 'مالکان نهایی',
  directors: 'مدیران',
  contact: 'تماس با ما',
  contactEmail: 'ایمیل تماس',
  contactPhone: 'تلفن تماس',
  submitReport: 'ثبت گزارش',
  youHaveEditedKeyMemberDetailsLeavingNowMay:
    'اطلاعات افراد کلیدی را تغییر داده‌اید. با خروج ممکن است تغییرات ذخیره نشوند.',
  member: 'عضو',
  addKeyMember: 'افزودن فرد کلیدی',
  firstName2: 'نام',
  lastName2: 'نام خانوادگی',
  roleTitle: 'سمت',
  dateOfBirth2: 'تاریخ تولد',
  placeOfBirth2: 'محل تولد',
  countryOfResidence: 'کشور محل اقامت',
  idNumber2: 'شماره شناسایی',
  taxIdNumber: 'شناسه مالیاتی',
  sourceOfFundsIncome: 'منبع درآمد یا تأمین مالی',
  estimatedNetWorth: 'برآورد خالص دارایی',
  youHaveEditedClientInformationLeavingNowMayLose:
    'اطلاعات مشتری را تغییر داده‌اید. با خروج ممکن است تغییرات ذخیره نشوند.',
  identity: 'مشخصات هویتی',
  identificationDocument: 'مدرک شناسایی',
  idPassportNumber: 'شماره شناسایی یا گذرنامه',
  taxIdentificationNumber2: 'شناسه مالیاتی',
  employmentStatus2: 'وضعیت اشتغال',
  sourceOfFunds2: 'منبع درآمد',
  accountUsePurpose: 'هدف از افتتاح حساب',
  knowYourCustomerKyc: 'شناخت مشتری حقیقی (KYC)',
  knowYourBusinessKyb: 'شناخت مشتری حقوقی (KYB)',
  couldNotDiscardReport: 'حذف پیش‌نویس انجام نشد',
  reportType: 'نوع گزارش',
  youChoseThisVerificationPathForThisReportTo:
    'برای انتخاب نوع دیگری از بررسی، باید گزارش جدیدی شروع کنید.',
  changeReportType: 'تغییر نوع گزارش',
  changeReportType2: 'نوع گزارش تغییر کند؟',
  switchingTheReportTypeWillPermanentlyDiscardThisDraft:
    'با تغییر نوع گزارش، این پیش‌نویس و همه فایل‌های آن برای همیشه حذف می‌شوند. این کار قابل بازگشت نیست.',
  discarding: 'در حال حذف…',
  discardAndStartOver: 'حذف و شروع دوباره',
  clientName: 'نام مشتری',
  clientType: 'نوع مشتری',
  status: 'وضعیت',
  riskLevel: 'میزان ریسک',
  actions: 'عملیات',
  savedDraft: 'پیش‌نویس ذخیره‌شده',
  clientAdded: '✓ مشتری اضافه شد',
  clientRejected: '× مشتری رد شد',
  pendingReview: '؟ در انتظار بررسی',
  continueDraft: 'ادامه پیش‌نویس',
  viewReport: 'مشاهده گزارش',
  reportPending: 'گزارش در انتظار تکمیل',
  availableWhenGenerationIsComplete: 'پس از تکمیل گزارش در دسترس است',
  noReportsMatchTheseFilters: 'گزارشی با این فیلترها پیدا نشد.',
  reportStatus: 'وضعیت گزارش',
  completed: 'تکمیل‌شده',
  inProgress: 'در حال انجام',
  savedDrafts: 'پیش‌نویس‌های ذخیره‌شده',
  type: 'نوع',
  allTypes: 'همه انواع',
  kyc: 'KYC',
  kyb: 'KYB',
  period: 'بازه زمانی',
  allTime: 'همه زمان‌ها',
  thisWeek: 'این هفته',
  last30Days: '۳۰ روز گذشته',
  last6Months: '۶ ماه گذشته',
  lastYear: 'سال گذشته',
  drafts: 'پیش‌نویس‌ها',
  inProgress2: 'در حال انجام (',
  completed2: 'تکمیل‌شده (',
  pendingReview2: 'در انتظار بررسی',
  failedPartial: 'ناموفق / ناقص',
  riskFilter: 'فیلتر ریسک',
  allRisks: 'همه سطوح ریسک',
  high: 'بالا',
  medium: 'متوسط',
  low: 'پایین',
  reportHistory: 'سوابق گزارش‌ها',
  myReports: 'گزارش‌های من',
  reportsFound: 'گزارش پیدا شد',
  showing: 'نمایش',
  reportGenerationRestarted: 'تهیه گزارش دوباره شروع شد.',
  retryReportGeneration: 'تلاش دوباره برای تهیه گزارش',
  errorLoadingReports: 'گزارش‌ها بارگیری نشدند',
  searchReportsByNameTypeIdOrCaseId: 'جست‌وجوی گزارش بر اساس نام، نوع یا شناسه…',
  reportType2: 'نوع گزارش',
  inProcess: 'در حال پردازش (',
  noReportsFound: 'گزارشی پیدا نشد',
  noReportsMatchYourSearchCriteria: 'گزارشی با این مشخصات پیدا نشد.',
  thereAreNoReportsAvailableAtTheMoment: 'در حال حاضر گزارشی وجود ندارد.',
};
